export const SkyscraperIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <defs />
      <title>{"building-modern"}</title>
      <path d="M11,23.5V1.5a1,1,0,0,1,1-1h8a1,1,0,0,1,1,1V23a.5.5,0,0,1-.5.5Z" fill="#00e6ca" />
      <path d="M21,6.167V1.5a1,1,0,0,0-1-1H12a1,1,0,0,0-1,1V16.167Z" fill="#c4f0eb" />
      <path d="M13,23.5H3.5A.5.5,0,0,1,3,23V9.5a1,1,0,0,1,1-1h8a1,1,0,0,1,1,1Z" fill="#00e6ca" />
      <path d="M13,10.2V9.5a1,1,0,0,0-1-1H4a1,1,0,0,0-1,1V20.2Z" fill="#c4f0eb" />
      <path
        d="M13,23.5H3.5A.5.5,0,0,1,3,23V9.5a1,1,0,0,1,1-1h8a1,1,0,0,1,1,1Z"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M11,8.5v-7a1,1,0,0,1,1-1h8a1,1,0,0,1,1,1V23a.5.5,0,0,1-.5.5H13"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M19,23.5V21a.5.5,0,0,0-.5-.5h-2a.5.5,0,0,0-.5.5v2.5Z"
        fill="#f8fafc"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8,23.5V21a.5.5,0,0,0-.5-.5h-2A.5.5,0,0,0,5,21v2.5Z"
        fill="#f8fafc"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1={3}
        y1={11.5}
        x2={7}
        y2={11.5}
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <line
        x1={11}
        y1={6.5}
        x2={15}
        y2={6.5}
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <line
        x1={11}
        y1={3.5}
        x2={17}
        y2={3.5}
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <line
        x1={3}
        y1={14.5}
        x2={5}
        y2={14.5}
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
};
